export default __webpack_public_path__ + "static/media/deliveryVisuals@2x.de4b3530.png";